// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2PTLL","signatureBlock":"Footer_signatureBlock__nhelV","signature":"Footer_signature__ydl_y"};